import React, { useState } from "react";
import styled from "styled-components";
import { FiChevronDown } from "react-icons/fi";
import { FAQData } from "../data/FAQData";

const Section = styled.section`
  background: #ffffff;
  padding: 5rem 1.5rem;
`;

const Wrap = styled.div`
  max-width: 820px;
  margin: 0 auto;
`;

const Eyebrow = styled.p`
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.85rem;
  color: #faa71e;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
`;

const Heading = styled.h2`
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  color: #0a2a4a;
  font-weight: 800;
  text-align: center;
  margin-bottom: 2.5rem;
`;

const Item = styled.div`
  background: #fffcf2;
  border-radius: 16px;
  margin-bottom: 0.75rem;
  overflow: hidden;
  border: 1px solid rgba(250, 167, 30, 0.15);
  transition: border-color 0.2s ease;

  ${({ $open }) => $open && "border-color: rgba(250, 167, 30, 0.5);"}
`;

const Trigger = styled.button`
  width: 100%;
  background: transparent;
  border: none;
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  font-size: 1.05rem;
  font-weight: 700;
  color: #0a2a4a;
  line-height: 1.4;

  svg {
    flex-shrink: 0;
    transition: transform 0.25s ease;
    color: #faa71e;
    transform: ${({ $open }) => ($open ? "rotate(180deg)" : "rotate(0deg)")};
  }
`;

const Answer = styled.div`
  max-height: ${({ $open }) => ($open ? "500px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease;

  div {
    padding: 0 1.5rem 1.25rem;
    color: #2d3e56;
    line-height: 1.6;
  }
`;

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <Section id="faq">
      <Wrap>
        <Eyebrow>Întrebări frecvente</Eyebrow>
        <Heading>Avem răspunsul</Heading>
        {FAQData.map((item, i) => {
          const isOpen = open === i;
          return (
            <Item key={i} $open={isOpen}>
              <Trigger
                $open={isOpen}
                aria-expanded={isOpen}
                onClick={() => setOpen(isOpen ? -1 : i)}
              >
                <span>{item.q}</span>
                <FiChevronDown size={22} />
              </Trigger>
              <Answer $open={isOpen}>
                <div>{item.a}</div>
              </Answer>
            </Item>
          );
        })}
      </Wrap>
    </Section>
  );
};

export default FAQ;
